import { render, staticRenderFns } from "./buttons.vue?vue&type=template&id=3289cb60&scoped=true&"
var script = {}
import style0 from "./buttons.vue?vue&type=style&index=0&id=3289cb60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3289cb60",
  null
  
)

export default component.exports